import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";
import ZonnepanelenFAQ from "../components/faqs/ZonnepanelenFAQ";
import { Check, Phone } from "lucide-react";

function Zonnepanelen() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Zonnepanelen installatie - Elektraaanleggen.nl"
        description="Professionele zonnepanelen installatie voor duurzame energie. Onze experts zorgen voor een optimale installatie en rendement."
        schema={generateServiceSchema({
          name: "Zonnepanelen installatie",
          description:
            "Laat uw zonnepanelen professioneel installeren door onze experts. We zorgen voor een optimale installatie voor maximaal rendement en een duurzame toekomst.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />

      <Header />
      <HeroSection
        title="Zonnepanelen installatie"
        description="Stap over op zonne-energie met onze professionele installatie service. Onze experts zorgen voor een optimaal rendement."
        imageSrc="/images/longi-removebg-preview.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele installatie van zonnepanelen – Uw stap naar een
              duurzame toekomst
            </h2>
            <p>
              Investeren in zonnepanelen is een slimme keuze voor een duurzame
              en energiezuinige toekomst. Bij Elektra Aanleggen bieden we
              professionele installatie van zonnepanelen, waarbij we zorgen voor
              een naadloze integratie van de groepenkast tot de omvormer. Ons
              team van gecertificeerde installateurs staat klaar om u te
              begeleiden bij elke stap van het proces, zodat u kunt profiteren
              van maximale energieopbrengst en besparingen op uw
              energierekening.
            </p>
            <br></br>
            <p>
              Neem contact met ons op voor een vrijblijvend adviesgesprek en
              ontdek hoe u kunt profiteren van zonne-energie. Samen zetten we
              een stap naar een groenere toekomst!
            </p>
            <br></br>
            <p className="font-semibold">
              Maximaal rendement uit uw zonnepanelen
            </p>
            <br></br>
            <p>
              Bij Elektra Aanleggen zorgen wij ervoor dat uw zonnepanelen
              installatie optimaal presteert en u het maximale rendement
              behaalt. Door een zorgvuldige plaatsing en uitlijning houden we
              rekening met de oriëntatie, hellingshoek en schaduwvorming, zodat
              uw panelen altijd de hoogste energieopbrengst leveren.
            </p>
            <br></br>
            <p>
              Met een slim monitoringsysteem kunt u in real-time uw
              zonne-energieproductie volgen via een app of online dashboard. Dit
              geeft u inzicht in uw opbrengst per paneel, verbruikspatronen en
              besparingen, zodat u uw energiebeheer kunt optimaliseren.
            </p>
            <br></br>
            <p>
              Onze installaties zijn klaar voor de toekomst en eenvoudig uit te
              breiden met thuisbatterijen of een slimme omvormer, waarmee u
              opgewekte stroom opslaat voor later gebruik. Dit maakt uw
              huishouden zelfvoorzienender en minder afhankelijk van stijgende
              energietarieven.
            </p>
            <br></br>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Optimale positionering voor maximale opbrengst
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  24/7 monitoring van uw zonne-energie
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Voorbereid op uitbreidingen zoals thuisbatterijen
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Duurzame en betrouwbare installatie met A-merk materialen
                </span>
              </li>
            </ul>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Direct Gratis Offerte
                </span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />: 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="Zonnepanelen installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/warmtepomp-met-zonnepanelen.jpg"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Onze werkwijze in zes stappen:
            </h2>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Voorstudie en advies op maat: We starten met een grondige
                  analyse van uw dakstructuur, hellingshoek, oriëntatie en
                  eventuele schaduwvorming. Op basis hiervan adviseren we over
                  het optimale aantal zonnepanelen en het type omvormer dat het
                  beste bij uw situatie past.​
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Montage van de draagstructuur: Onze installateurs bevestigen
                  een stevige draagstructuur op uw dak. Bij schuine daken
                  plaatsen we haken onder de dakpannen met daarop rails, terwijl
                  we bij platte daken gebruikmaken van metalen profielen met de
                  juiste hellingsgraad.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Installatie van de zonnepanelen: De zonnepanelen worden
                  zorgvuldig op de draagstructuur gemonteerd en elektrisch met
                  elkaar verbonden om een efficiënte energieopbrengst te
                  garanderen.​
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Plaatsing van de omvormer: De omvormer, die de opgewekte
                  gelijkstroom omzet in bruikbare wisselstroom, wordt op een
                  strategische plek geïnstalleerd, bij voorkeur dicht bij de
                  meterkast en in een goed geventileerde ruimte.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Bekabeling en aansluiting: We zorgen voor een veilige
                  bekabeling tussen de zonnepanelen, de omvormer en de
                  meterkast. Indien nodig passen we de meterkast aan of
                  installeren we een PV-verdeler om de installatie op een eigen
                  groep aan te sluiten.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Keuring en inbedrijfstelling: Na afronding van de installatie
                  voeren we een grondige keuring uit om te controleren of alles
                  voldoet aan de geldende normen. Vervolgens stellen we het
                  systeem in bedrijf en begeleiden we u bij het monitoren van de
                  prestaties.​
                </span>
              </li>
            </ul>
            <br></br>
            <p>Waarom kiezen voor Elektra Aanleggen?</p>
            <br></br>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Erkende installateurs: Onze vakmensen zijn volledig
                  gecertificeerd en werken volgens de laatste NEN 1010 en NEN
                  7250 normen, wat zorgt voor een veilige en betrouwbare
                  installatie.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Hoogwaardige materialen: We maken uitsluitend gebruik van
                  A-merk zonnepanelen en omvormers, wat bijdraagt aan een lange
                  levensduur en hoge rendementen.​
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Complete service: Van de eerste analyse tot de uiteindelijke
                  aansluiting op het net, wij verzorgen het volledige traject en
                  regelen alle benodigde vergunningen en keuringen.​
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="min-w-5 min-h-5 w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Snelle installatie: In de meeste gevallen kunnen we de
                  installatie binnen één dag afronden, met minimale overlast
                  voor u.
                </span>
              </li>
            </ul>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Direct Gratis Offerte
                </span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />: 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <img
                alt="Zonnepanelen monitoring"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <ZonnepanelenFAQ />

      <ServiceHighlights />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Zonnepanelen;
